<router-outlet>
    <!-- <app-spinner></app-spinner> -->
    <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "timer" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
    <!-- <ngx-spinner bdColor = "rgba(35,37,37,0.8)" size = "medium" color = "#f9fafa" type = "ball-pulse-sync" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner> -->
</router-outlet>

<div id="footer" style="background-color: #000000;">
    <div class="row" style="padding: 10px; margin-top: 5px;">
    <div class="col text-light">
    <a href="https://www.nanoh2owater.com/about-us/contact-information/" target="_blank" rel="noopener noreferrer" style="color: white;"><b> Contact Us </b></a> <b>|</b> <a style="color: white;" [routerLink]="['/component/resources']"><b> Resources </b></a> <b>|</b> <a style="color: white;"><b> Help </b></a>
</div>
    <div class="col">
    <h5 class="text-right text-light" >© {{ currentYear }} NanoH2O, Ltd. All Rights Reserved.</h5>
</div>
</div>
</div>
